module.exports = __webpack_public_path__ + "media/images/page/about03-5d3387daf231f0f407c804035ad24775.jpg";